export const AUTH_LOGIN_START          = 'AUTH_LOGIN_START';
export const AUTH_LOGOUT               = 'AUTH_LOGOUT';
export const AUTH_UPDATE_USER          = 'AUTH_UPDATE_USER';

export const UPDATE_ADMIN_STATUS       = 'UPDATE_ADMIN_STATUS';